// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import ReactDatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import * as DateLocale from 'date-fns/locale';
import TimePicker from './TimePicker';
import DateTimePicker from './DateTimePicker';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import If from './If';
var DatePicker = ReactDatePicker;

var gridLocale: string = null;
var gridLocaleSet = false;

interface TableProps extends React.PropsWithChildren<{}> {
    columns: ColumnOption[];
    dataSource: any[];
    requestData: (size: number, pageNum: number, callback: any) => void;
    pageSize: number;
    pageNum: number;
    keyColumn: string;
    handleSort?: (column: string, direction: string, callback: any) => void;
    handleFilter?: (filterObj: { [id: string]: string | { start?: string, end?: string } }, callback: any) => void;
    loading?: boolean;
    height?: number;
    fontSize?: string;
    onRowClick?: (e:any, rowData: any) => void;
}

interface TableState {
    columns?: ColumnState[];
    requestingNew?: boolean;
    requestingNextPage?: boolean;
    left?: number;
}

function configureGridLocale() {
    if (gridLocaleSet)
        return;

    let locale = InovxLoader.getSyncfusionLocale() as string;
    switch (locale.toLowerCase()) {
        case "zh-cn":
            registerLocale("zh-CN", DateLocale.zhCN);
            break;
        case "ja-jp":
            registerLocale("ja-JP", DateLocale.ja);
            break;
        default:
            locale = null;
            break;
    }

    gridLocaleSet = true;
    gridLocale = locale;
}

class FluxGrid extends React.Component<TableProps, TableState> {
    _contentRef = createRef<HTMLDivElement>();
    _headerRef = createRef<any>();
    _disableCall: boolean;
    constructor(props: TableProps) {
        super(props);

        this._disableCall = false;

        this.state = { columns: [], requestingNew: false, requestingNextPage: false, left: 0 };

        configureGridLocale();
    }

    private onColumnResized = (newColumns: ColumnState[]) => {
        this.setState({ columns: newColumns } as any);
    }

    private _requestNew = () => {
        this.setState({
            requestingNew: true,
            requestingNextPage: false
        });
    }

    private handleScroll = (e: Event) => {

    }

    private handleContentScroll = (e: React.UIEvent) => {
        var div = e.target as HTMLDivElement;
        var left = div.scrollLeft;
        var stateObj: any = {};

        stateObj.left = left;

        if (div.scrollHeight - 30 < div.clientHeight + div.scrollTop && !this._disableCall) {
            stateObj.requestingNextPage = true;
            this._disableCall = true;
            this.setState(stateObj);
            this.props.requestData(this.props.pageSize, this.props.pageNum + 1, () => {
                this.setState({ requestingNextPage: false });
                setTimeout(() => { this._disableCall = false; }, 200);
            });
        } else if (this.state.left !== left) {
            this.setState(stateObj);
        }
    }

    private handleSort = (column: ColumnState) => {
        if (this.props.handleSort && column.enableSort) {
            this._requestNew();

            var sortDirection: any = null;
            if (column.sortDirection === 'asc') {
                sortDirection = 'desc';
                //} else if (column.sortDirection === 'desc') {
                //    sortDirection = '';
            } else {
                sortDirection = 'asc'
            }


            this.props.handleSort(column.id, column.sortDirection, () => {
                column.sortDirection = sortDirection;

                this.state.columns.forEach((otherColumn) => {
                    if (otherColumn.id !== column.id) {
                        otherColumn.sortDirection = '';
                    } else {
                        otherColumn.sortDirection = sortDirection;
                    }
                });

                this.setState({ requestingNew: false });
            });
        } else {

        }
    }

    private handleFilter = (filterObj: { [id: string]: string | { start?: string, end?: string } }) => {
        this._requestNew();
        this.props.handleFilter(filterObj, () => {
            this.setState({ requestingNew: false });
        });
    }

    public handleClearFilters = (newFilters?: any) => {
        (this._headerRef.current as any)._onClearAllFilters(newFilters);
    }

    public handleRefresh = () => {
        (this._headerRef.current as any)._onRefresh();
    }

    public setFilter = (columnName: string, filterValue: string) => {
        (this._headerRef.current as any)._setFilterExternally(columnName, filterValue);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            columns: JSON.parse(JSON.stringify(this.props.columns))
        });
    }

    componentDidMount() {
        var headerHeight = (ReactDOM.findDOMNode(this._headerRef.current as React.Component<any, any>) as Element).clientHeight;
        var contentHeight = this.props.height ? this.props.height - headerHeight : 400 - headerHeight;
        (this._contentRef.current as HTMLDivElement).style.height = contentHeight + 'px';
    }

    UNSAFE_componentWillReceiveProps(nextProps: TableProps) {
        this.setState({} as any);
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div className='tg-table' style={{ fontSize: this.props.fontSize }}>
                <If condition={this.state.requestingNew} class={'temp-modal-loader'}>
                    <div className="action-in-progress-loader-sm"></div>
                </If>
                <div className='tg-grid'>
                    <GridHeader columns={this.state.columns} onColumnResize={this.onColumnResized} onColumnSort={this.handleSort} onColumnFilter={this.handleFilter} left={this.state.left} ref={this._headerRef} />
                    <div className='tg-content-container' ref={this._contentRef} onScroll={this.handleContentScroll}>
                        <div className='tg-content' style={{ width: getWidth(this.state.columns) }} >
                            {this.props.dataSource.map((row: any, indx: number) => {
                                return <GridRow key={row[this.props.keyColumn]} data={row} columns={this.state.columns} alt={indx % 2 === 1} onRowClick={this.props.onRowClick} />
                            }) }
                            {this.state.requestingNextPage ?
                                <div className='tg-row' style={{ width: getWidth(this.state.columns) + 'px' }}>
                                    <div style={{ height: '60px', verticalAlign: 'middle', lineHeight: '30px', padding: '15px' }}>{InovxLoader.t("common:message.loading")}</div>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

function getWidth(columns: ColumnOption[]) {
    var width = 0;
    for (var k in columns) {
        width += columns[k]['width'];
    }
    return width;
}

interface RowProps extends React.PropsWithChildren<{}> {
    columns: ColumnOption[];
    data: any;
    alt?: boolean;
    onRowClick: (e:any, rowData: any) => void;
}

const GridRow = (props: RowProps) => (
    <div className={`tg-row ${props.alt ? ' tg-alt' : ''} ${props.onRowClick ? ' tg-link' : ''}`} style={{ width: `${getWidth(props.columns)}px` }}
        onClick={(e) => (props.onRowClick) ? props.onRowClick(e, props.data) : null}>
        { props.columns.map((column: ColumnOption, index: number) => {
            return (<GridCell width={column.width} key={index}>{props.data[column.id]}</GridCell>);
        }) }
    </div>
)

interface ColumnOption {
    name: string;
    id: string;
    width?: number;
    filterType?: string;
    filteringOptions?: { Option: string, Value: number, Checked: boolean, Default: boolean }[]; // Used when there is a list (e.g. drop downs, check boxes, etc)
    enableSort?: boolean;
}

interface ColumnState extends ColumnOption {
    sortDirection?: string;
    showFilter: boolean;
    filterValue: any;
    tempFilterValue: any;
}

interface GridHeaderState {
    columns: ColumnState[];
    width: number;
    position: { x: number, y: number };
    target: HTMLDivElement;
    columnResize: ColumnState;
    filterDisplayLeft?: boolean;
}

interface GridHeaderProps extends React.PropsWithChildren<{}> {
    columns: ColumnState[];
    onColumnResize: (columns: ColumnState[]) => void;
    onColumnSort: (column: ColumnState) => void;
    onColumnFilter: (filterObj: { [id: string]: string }) => void;
    left: number;
}

class GridHeader extends React.Component<GridHeaderProps, GridHeaderState> {
    _headerRef = createRef<HTMLDivElement>();
    constructor(props: GridHeaderProps) {
        super(props);

        this.state = {} as any;
    }

    private onMouseDown = (column: any, e: any) => {
        e.preventDefault();
        e.stopPropagation();
        
        this.setState({            
            position: {
                x: e.clientX,
                y: e.clientY
            },
            target: e.target,
            columnResize: column
        });

        window.addEventListener('mouseup', this.onMouseUp);
        window.addEventListener('mousemove', this.onMouseMove);
    }

    private onMouseMove = (e: any) => {

        if (this.state.columnResize) {
            var columnMin = 65;
            var canResize = this.state.target.getBoundingClientRect().left < e.clientX;
            var increment = (e.clientX - this.state.position.x);

            if (increment < 0) {
                if (this.state.columnResize.width + increment > columnMin) {
                    this.state.columnResize.width += increment;
                } else {
                    this.state.columnResize.width = columnMin;
                }
                this.setState({
                    width: getWidth(this.state.columns),
                    position: { x: e.clientX, y: e.clientY }
                } as any);
            } else if (increment > 0 && canResize) {
                this.state.columnResize.width += increment;
                this.setState({
                    width: getWidth(this.state.columns),
                    position: { x: e.clientX, y: e.clientY }
                } as any);
            }

            e.stopPropagation();
        }
    }

    private onMouseUp = (e: any) => {

        if (this.state.columnResize) {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);

            e.preventDefault();
            e.stopPropagation();

            this.setState({
                columnResize: null
            })

            this.props.onColumnResize(this.state.columns);
        }
    }

    private onFilterClicked = (e: any, column: ColumnState) => {
        e.stopPropagation();

        var initialValue = column.showFilter;
        this.state.columns.forEach((column) => {
            column.showFilter = false;
        });

        column.showFilter = !initialValue;
        let positionX: number = e.clientX; //e.screenX;
        let width = window.innerWidth / 2;
        let displayLeft = true;
        //if (positionX > width)
        if (positionX > width) displayLeft = false;
        this.setState({ filterDisplayLeft: displayLeft });
    }

    private _onFilterValueChanged = (e: any, column: ColumnState) => {
        column.tempFilterValue = e.target.value;
        this.setState({} as any);
    }

    private _onStartDateChanged = (date: any, column: ColumnState) => {
        column.tempFilterValue['start'] = date;
        this.setState({} as any);
    }

    private _setDefaultStartDate = (column: ColumnState) => {
        var startDateTime = column.tempFilterValue['start'];
        var endDateTime = column.tempFilterValue['end'];

        if (!startDateTime) {
            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            var time = today.getHours() + ":" + today.getMinutes();
            startDateTime = date + ' ' + "12:00 AM";
            endDateTime = date + " " + time;
            column.tempFilterValue['start'] = startDateTime;
            column.tempFilterValue['end'] = endDateTime;
            this.setState({} as any );
        } 
    }

    private _onEndDateChanged = (date: any, column: ColumnState) => {
        column.tempFilterValue['end'] = date;
        this.setState({} as any);
    }

    private _onStartTimeChanged = (time: string, column: ColumnState) => {
        column.tempFilterValue['start'] = time;
        this.setState({} as any);
    }

    private _onEndTimeChanged = (time: string, column: ColumnState) => {
        column.tempFilterValue['end'] = time;
        this.setState({} as any);
    }

    private _onCheckboxChange = (e: any, column: ColumnState, enabledOptions: {Option: string, Value: number}[]) => {
        column.tempFilterValue = enabledOptions;
        this.setState({} as any);
    }

    private _setFilterExternally = (columnName: string, filterValue: string) => {
        this.state.columns.forEach((column) => {
            if (column.id.toLowerCase() === columnName.toLowerCase()) {
                this._setFilterValue(column, filterValue);
            }
        });

        this.setState({} as any);
        this._invokeFilter();
    }

    private _setFilterValue = (column: ColumnState, filterValue: string) => {
        if (column.filterType === 'list') {
            // Match on Value, not Option: Option holds the localized label, so matching
            // on it only selects the intended entries when the UI is in English.
            var filterValueArray = filterValue.split(",");
            column.filterValue.forEach((val: any) => {
                if (filterValueArray.indexOf(String(val.Value)) >= 0) {
                    val.Checked = true;
                }
            });
            column.tempFilterValue = cloneObject(column.filterValue);
        }
        else {
            column.filterValue = filterValue;
            column.tempFilterValue = filterValue;
        }
    }

    private _clearFilterValue = (column: ColumnState, useListDefault: boolean) => {
        if (column.filterType === 'date' || column.filterType === 'time' || column.filterType === 'datetime') {
            column.filterValue['start'] = null;
            column.filterValue['end'] = null;
            column.tempFilterValue = cloneObject(column.filterValue);
        } else if (column.filterType === 'list') {
            column.filterValue.forEach((obj: any) => {
                obj.Checked = (useListDefault) ? obj.Default : true;
            });
            column.tempFilterValue = cloneObject(column.filterValue);
        } else {
            column.filterValue = '';
            column.tempFilterValue = '';
        }
    }

    private _onFilterCleared = (column: ColumnState) => {
        this._clearFilterValue(column, false);

        this.setState({} as any);
        this._onFilter(column);
    }

    private _onClearAllFilters = (newFilters?: any) => {
        this.state.columns.forEach((column) => {
            var newFilterValue = (newFilters) ? newFilters[column.id] : null;
            if (newFilterValue) {
                this._setFilterValue(column, newFilterValue);
            }
            else {
                this._clearFilterValue(column, true);
            }
        });
        this.setState({} as any);

        this._invokeFilter();

    }

    private _onRefresh = () => {
        this.setState({} as any);
        this._invokeFilter();
    }

    private _onFilter = (column: ColumnState) => {
        column.filterValue = column.tempFilterValue;
        column.showFilter = false;

        this._invokeFilter();
    }

    private _invokeFilter = () => {
        var filterObj: { [id: string]: string | { start?: string, end?: string } } = {};
        this.state.columns.forEach((colState) => {
            if (colState.filterType === 'date' || colState.filterType === 'datetime' || colState.filterType === 'time') {
                if (colState.filterValue.start || colState.filterValue.end) {
                    filterObj[colState.id] = {};
                    if (colState.filterValue.start) {
                        (filterObj[colState.id] as any)['start'] = colState.filterValue.start;
                    }
                    if (colState.filterValue.end) {
                        (filterObj[colState.id] as any)['end'] = colState.filterValue.end;
                    }
                }
            } else if (colState.filterValue) {
                filterObj[colState.id] = colState.filterValue;
            }
        });

        this.props.onColumnFilter(cloneObject(filterObj));
    }

    private _onWindowMouseClick = (e: any) => {
        if (!($(e.target).closest('.tg-filter-container').length || $(e.target).closest('.react-datepicker').length || $(e.target).closest('.e-dt-done').length
            || $(e.target).closest('.datetime-picker').length || $(e.target).closest('.e-time-popup').length
            || $(e.target).closest('.current-month').length || $(e.target).closest('.other-month').length))
        {
            var setState = false;
            for (var k in this.state.columns) {
                if (this.state.columns[k].showFilter) {
                    this.state.columns[k].showFilter = false;
                    setState = true;
                }
                if (this.state.columns[k].filterType === 'date') {
                    var filterVal = this.state.columns[k].filterValue;
                    this.state.columns[k].tempFilterValue.start = filterVal.start ? filterVal.start.clone() : null;
                    this.state.columns[k].tempFilterValue.end = filterVal.end ? filterVal.end.clone() : null;
                } else if (this.state.columns[k].filterType === 'time' || this.state.columns[k].filterType === 'datetime') {
                    var filterVal = this.state.columns[k].filterValue;
                    this.state.columns[k].tempFilterValue.start = filterVal.start;
                    this.state.columns[k].tempFilterValue.end = filterVal.end;
                } else {
                    this.state.columns[k].tempFilterValue = this.state.columns[k].filterValue;
                } 
            }
            if (setState) {
                this.setState({} as any);
            }
        }
    }

    UNSAFE_componentWillMount() {
        let columns: ColumnState[] = JSON.parse(JSON.stringify(this.props.columns));
        for (var k in columns) {
            if (columns[k].filterType === 'list' && columns[k].filteringOptions) {
                columns[k].filterValue = cloneObject(columns[k].filteringOptions);
            }

            if (!columns[k].filterValue) {
                if (columns[k].filterType === 'date' || columns[k].filterType === 'time' || columns[k].filterType === 'datetime' ) {
                    columns[k].filterValue = { start: null, end: null };
                    columns[k].tempFilterValue = cloneObject(columns[k].filterValue);
                } else {
                    columns[k].filterValue = '';
                    columns[k].tempFilterValue = '';
                }
            } else {
                columns[k].tempFilterValue = cloneObject(columns[k].filterValue);
            }
        }

        this.setState({
            columns: columns,
            width: getWidth(columns)
        });
    }

    componentDidMount() {
        window.addEventListener("click", this._onWindowMouseClick);
    }

    UNSAFE_componentWillReceiveProps(nextProps: GridHeaderProps) {
        if (typeof nextProps.left === 'number') {
            (this._headerRef.current as any).style.transform = `translateX(${nextProps.left * -1}px)`;
        }
    }

    componentWillUnmount() {
        window.removeEventListener("click", this._onWindowMouseClick);
    }



    render() {
        var prevColumn: ColumnState = null;
        var filterPopupClass = "tg-hdr-filter tg-hdr-filter-left";
        if (!this.state.filterDisplayLeft)
            filterPopupClass = "tg-hdr-filter tg-hdr-filter-right";
        return (
            <div className='tg-header-container'>
                <div className='tg-header tg-row' style={{ width: `${this.state.width}px` }} ref={this._headerRef}>
                {
                        this.state.columns.map((column) => {
                            var prevColumnHandler = prevColumn ? <div className='tg-handle-prev' onMouseDown={this.onMouseDown.bind(this, prevColumn)} ></div> : null;
                        prevColumn = column;

                        var sort: any = null;
                        if (column.sortDirection === 'asc') {
                            sort = <i className="fa fa-sort-asc" aria-hidden="true"></i>;
                        } else if (column.sortDirection === 'desc') {
                            sort = <i className="fa fa-sort-desc" aria-hidden="true"></i>
                        }

                        var filter: any = null;
                        switch (column.filterType) {
                            case 'string':
                            case 'number':
                                filter = <TextFilter onFilter={this._onFilter} onValueChanged={this._onFilterValueChanged} onClear={this._onFilterCleared} column={column} />;
                                break;
                            case 'datetime':
                                filter = <DateTimeFilter onFilter={this._onFilter} onStartDateTimeChanged={this._onStartDateChanged} onEndDateTimeChanged={this._onEndDateChanged} onClear={this._onFilterCleared} column={column} />;
                                break;
                            case 'date':
                                filter = <DateFilter onFilter={this._onFilter} onStartDateChanged={this._onStartDateChanged} onEndDateChanged={this._onEndDateChanged} onClear={this._onFilterCleared} column={column} />;
                                break;
                            case 'time':
                                filter = <TimeFilter onFilter={this._onFilter} onStartTimeChanged={this._onStartTimeChanged} onEndTimeChanged={this._onEndTimeChanged} onClear={this._onFilterCleared} column={column} />;
                                break;
                            case 'list':
                                filter = <CheckboxFilter filterOptions={column.filterValue} onCheckboxChange={this._onCheckboxChange} onFilter={this._onFilter} onClear={this._onFilterCleared} column={column} />;
                                break;
                        }

                            var filterColumn = <div className={filterPopupClass }>
                            {filter}
                        </div>;

                        var columnStyle: React.CSSProperties = { width: `${column.width - 30}px` };

                        var hasFilterValue = false;
                        if (column.filterValue) {
                            if (column.filterType === 'date' || column.filterType === 'time' || column.filterType === 'datetime') {
                                if (column.filterValue.start || column.filterValue.end) {
                                    hasFilterValue = true;
                                }
                            } else if (column.filterType === 'list') {
                                column.filterValue.forEach((obj: any) => {
                                    if (!obj.Checked) {
                                        hasFilterValue = true;
                                    } 
                                });
                            } else if (column.filterValue.length > 0) {
                                hasFilterValue = true;
                            }
                        }

                        return (
                            <GridCell width={column.width} key={column.id}>
                                {prevColumnHandler}
                                <div className={`tg-hdr-ctnt ${column.enableSort ? 'sort' : ''}`} onClick={() => this.props.onColumnSort(column) } style={columnStyle}>
                                    <div className='tg-title'>{column.name} {sort}</div>
                                </div>
                                {column.filterType ?
                                    <div className='tg-filter-container'>
                                        <div className={`tg-filter-trigger ${hasFilterValue ? 'has-value' : ''}` } onClick={(event) => this.onFilterClicked(event, column) }>
                                            <i className="fa fa-filter" aria-hidden="true"></i>
                                        </div>
                                        {column.showFilter ? filterColumn : null}
                                    </div>
                                    : null
                                }
                                <div className='tg-handle' onMouseDown={(event) => this.onMouseDown(column, event) } ></div>
                            </GridCell>
                        );
                    })
                }
                </div>
        </div>);
    }

}

interface CellProps extends React.PropsWithChildren<{}> {
    width: number;
    onClick?: any;
}

interface FilterProps extends React.PropsWithChildren<{}> {
    column: ColumnState;
    onFilter: any;
    onClear: any;
}

interface DateFilterProps extends FilterProps {
    onStartDateChanged: any;
    onEndDateChanged: any;
}

interface DateTimeFilterProps extends FilterProps {
    onStartDateTimeChanged: any;
    onEndDateTimeChanged: any;
}

const DateFilter = (props: DateFilterProps) => {
    var startDate = props.column.tempFilterValue['start'];
    var endDate = props.column.tempFilterValue['end'];
    
    return (
        <div className='tg-text-filter'>
            <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.startDate")}</div>
            <DatePicker className='tg-filter-input' dateFormat={InovxLoader.getLocaleData().datePattern} locale={gridLocale} selected={startDate} maxDate={endDate}
                startDate={startDate} endDate={endDate} onChange={(date?: any) => props.onStartDateChanged(date, props.column) }/>
            <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.endDate") }</div>
            <DatePicker className='tg-filter-input' dateFormat={InovxLoader.getLocaleData().datePattern} locale={gridLocale} selected={endDate} minDate={startDate}
                startDate={startDate} endDate={endDate} onChange={(date?: any) => props.onEndDateChanged(date, props.column) }/>
            <button className='tg-filter-btn btn btn-primary' onClick={() => props.onFilter(props.column) }>{InovxLoader.t("common:fluxGrid.filter") }</button>
            <button className='tg-filter-btn btn btn-default' onClick={() => props.onClear(props.column) }>{InovxLoader.t("common:fluxGrid.clear") }</button>
        </div>
    );
}

const DateTimeFilter = (props: DateTimeFilterProps) => {
    var startDateTime = props.column.tempFilterValue['start'];
    var endDateTime = props.column.tempFilterValue['end'];    
   
    if (!startDateTime) {
        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        var time = today.getHours() + ":" + today.getMinutes();
        startDateTime = date + ' ' + "12:00 AM";
        endDateTime = date + " " + time;
        props.column.tempFilterValue['start'] = startDateTime;
        props.column.tempFilterValue['end'] = endDateTime;
        
    }    

    return (
        <div className='tg-text-filter'>
            <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.startDateTime")}</div>
            <DateTimePicker value={startDateTime} onChange={(dateTime?: any) => props.onStartDateTimeChanged(dateTime, props.column)} id="fluxGridStartDateTime" />
            <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.endDateTime")}</div>
            {/*<DateTimePickerComponent id="datetimepicker2" placeholder="Select an end date and time" />*/}
            <DateTimePicker value={endDateTime} onChange={(dateTime?: any) => props.onEndDateTimeChanged(dateTime, props.column)} id="fluxGridEndDateTime" />
            <button className='tg-filter-btn btn btn-primary' onClick={() => props.onFilter(props.column)}>{InovxLoader.t("common:fluxGrid.filter")}</button>
            <button className='tg-filter-btn btn btn-default' onClick={() => props.onClear(props.column)}>{InovxLoader.t("common:fluxGrid.clear")}</button>
        </div>
    );
}

interface TimeFilterProps extends FilterProps {
    onStartTimeChanged: any;
    onEndTimeChanged: any;
}

const TimeFilter = (props: TimeFilterProps) => {
    var startTime = props.column.tempFilterValue['start'];
    var endTime = props.column.tempFilterValue['end'];

    return (
        <div className='tg-text-filter'>
            <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.startTime")}</div>
            <TimePicker value={startTime} interval={30} timeFormat="HH:mm" className={startTime ? 'active' : ''}
                onChange={(date?: any) => props.onStartTimeChanged(date, props.column) } id="fluxGridStartTime" />
            <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.endTime")}</div>
            <TimePicker value={endTime} interval={30} timeFormat="HH:mm" className={endTime ? 'active' : ''}
                onChange={(date?: any) => props.onEndTimeChanged(date, props.column) } id="fluxGridEndTime" />
            <button className='tg-filter-btn btn btn-primary' onClick={() => props.onFilter(props.column) }>{InovxLoader.t("common:fluxGrid.filter") }</button>
            <button className='tg-filter-btn btn btn-default' onClick={() => props.onClear(props.column) }>{InovxLoader.t("common:fluxGrid.clear") }</button>
        </div>
    );

}

interface TextFilterProps extends FilterProps {
    onValueChanged: any;
}

const TextFilter = (props: TextFilterProps) => (
    <div className='tg-text-filter'>
        <div className='tg-filter-title'>{InovxLoader.t("common:fluxGrid.filterValue")}</div>
        <input className='tg-filter-input' type='text' value={props.column.tempFilterValue} onChange={(e: any) => props.onValueChanged(e, props.column) }/>
        <button className='tg-filter-btn btn btn-primary' onClick={() => props.onFilter(props.column) }>{InovxLoader.t("common:fluxGrid.filter") }</button>
        <button className='tg-filter-btn btn btn-default' onClick={() => props.onClear(props.column) }>{InovxLoader.t("common:fluxGrid.clear") }</button>
    </div>
)

interface CheckboxFilterProps extends FilterProps {
    filterOptions: { Option: string, Value: number, Checked: boolean }[];
    onCheckboxChange: any;
}

class CheckboxFilter extends React.Component<CheckboxFilterProps, any> {
    constructor(props: CheckboxFilterProps) {
        super(props);

    }

    _onCheckboxClick = (e: any, filterOption: { Option: string, Value: number, Checked: boolean }) => {

        var enabledBoxes = cloneObject(this.props.column.tempFilterValue);

        enabledBoxes.forEach((box: any) => {
            if (box.Option === filterOption.Option) {
                box.Checked = e.target.checked ? true : false;
            }
        });



        this.props.onCheckboxChange(e, this.props.column, enabledBoxes)
    }

    render() {

        return (
            <div className="tg-text-filter">
                <div className="tg-filter-title">{InovxLoader.t("common:fluxGrid.selectOptions")}</div>
                {this.props.filterOptions.map((filterOption) => {
                    return (
                        <Checkbox boxName={filterOption.Option}
                            boxValue={filterOption.Option}
                            checked={filterOption.Checked}
                            onCheckboxClick={(e: any) => this._onCheckboxClick(e, filterOption)}
                            className="tg-checkbox-container"
                            key={filterOption.Option}
                        />
                    )
                })}
                <button className='tg-filter-btn btn btn-primary' onClick={() => this.props.onFilter(this.props.column)}>{InovxLoader.t("common:fluxGrid.filter")}</button>
                <button className='tg-filter-btn btn btn-default' onClick={() => this.props.onClear(this.props.column)}>{InovxLoader.t("common:fluxGrid.clear")}</button>
            </div>
        )
    }
}

interface CheckboxProps extends React.PropsWithChildren<{}> {
    boxName: string;
    boxValue: any;
    onCheckboxClick: any;
    checked: boolean;
    className?: string;
}

interface CheckboxState {
    checked: boolean;
}

class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
    constructor(props: CheckboxProps) {
        super(props);

        this.state = {
            checked: this.props.checked
        }
    }
    _handleCheckboxClick = (e: any) => {
        if (e.target.checked) {
            this.setState({
                checked: true
            });
        } else {
            this.setState({
                checked: false
            });
        }

        this.props.onCheckboxClick(e)
    }
    render() {
        const checkBoxProps = {
            type: "checkbox",
            style: { marginRight: "5px" },
            onChange: (e: any) => this._handleCheckboxClick(e),
            checked: this.state.checked
        }

        return (
            <label className={this.props.className} key={this.props.boxName}>
                <input {...checkBoxProps} />
                {this.props.boxName}
            </label>
        )
    }
}
const GridCell = (props: CellProps) => (
    <div className='tg-cell' style={{ width: `${props.width}px` }} onClick={props.onClick}>
        {props.children}
    </div>
)

function cloneObject(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}

export default FluxGrid;